import createRouter from './router.js';
import { store } from './store.js';
import { checkKetvStatus } from '../helpers/ketv.js';




// ---- GLOBAL COMPONENTS ----
import HeaderUser from '../components/header_user.js';
import MainMenu from '../components/main_menu.js';
import MediaPlayer from '../components/media_player.js';

let header_user_instance = null;
let main_menu_instance = null;

if (typeof document !== 'undefined') {
    header_user_instance = HeaderUser(store);
    const $header_user = document.getElementById('HeaderUser');
    $header_user.innerHTML = header_user_instance.render();
    header_user_instance.onMount();


    main_menu_instance = MainMenu(store);
    const $main_menu = document.getElementById('MainMenu');
    $main_menu.innerHTML = main_menu_instance.render();
    main_menu_instance.onMount();

    const $global_container = document.getElementById('global');
    if ($global_container) {
        const player = MediaPlayer({}, store);
        $global_container.appendChild(player.render());
        player.onMount();

        window.App = window.App || {};
        window.App.MediaPlayer = player;
    }

    checkKetvStatus();
}



// const musicPlayer = MusicPlayer({}, store);
// globalRoot.appendChild(musicPlayer.render());
// musicPlayer.onMount();

// ---- ROUTER ----
import AccountConfirm from '../views/account/confirm.js';
import AccountDetails from '../views/account/details.js';
import AccountSubscription from '../views/account/subscription.js';
import AccountResetPassword from '../views/account/reset-password.js';
import Contact from '../views/contact.js';
import ForgottenPassword from "../views/forgotten_password.js";
import History from '../views/history.js';
import Home from '../views/home.js';
import Ketv from '../views/ketv.js';
import Login from '../views/login.js';
import Logout from '../views/logout.js';
import Privacy from '../views/privacy.js';
import {ProductView} from '../views/shop/product.js';
import Register from '../views/register.js';
import Shop from '../views/shop/main.js';
import ShopCheckout from '../views/shop/checkout.js';
import Subscriptions from '../views/subscriptions.js';
import Terms from '../views/terms.js';
import Unsubscribe from "../views/unsubscribe.js";
import Vod from '../views/vod/main.js';

const routes = {
    '/': Home,
    '/account/confirm': AccountConfirm,
    '/account/details': AccountDetails,
    '/account/subscription': AccountSubscription,
    '/account/reset-password': AccountResetPassword,
    '/contact': Contact,
    '/forgotten_password': ForgottenPassword,
    '/history': History,
    '/login': Login,
    '/logout': Logout,
    '/ketv': Ketv,
    '/privacy': Privacy,
    '/register': Register,
    '/shop': Shop,
    '/shop/checkout': ShopCheckout,
    '/shop/product/:product_id': ProductView,
    '/subscriptions': Subscriptions,
    '/terms': Terms,
    '/unsubscribe': Unsubscribe,
    '/vod': Vod,
};

const $mount_point = document.querySelector('#app');
export const router = createRouter(routes, $mount_point, [header_user_instance, main_menu_instance]);
